// Module
var code = "<script>let $ctrl</script> <molecule-panel-error error-type=\"update\" error-box-type=\"fixed\"></molecule-panel-error> <organ-edit-panel-profile overview-ui-settings=\"$ctrl.overviewUiSettings\" overview-ui-display-settings=\"$ctrl.overviewUiDisplaySettings\"></organ-edit-panel-profile> ";
// Exports
module.exports = code;